/** Whether the editor should request a signed URL for the receipt photo. */
export function shouldLoadExpenseImage(input: {
  isNewExpense: boolean;
  urlExpenseId: string | null;
  loadedExpenseId: string;
  imageKey: string;
  isLocalPreview: boolean;
}): boolean {
  if (input.isNewExpense || input.isLocalPreview) return false;
  if (!input.urlExpenseId || !input.imageKey) return false;
  // The form still holds the previous receipt until its fetch returns.
  // Loading that photo paints it on the receipt the arrows just opened.
  return String(input.loadedExpenseId) === String(input.urlExpenseId);
}
